<div class="categories-space">
	<ion-grid>
		<ng-container *ngTemplateOutlet="(hasItemsByLine$ | async) ? content : oldContent"></ng-container>
	</ion-grid>
</div>

<ng-template #content>
	<ion-row *ngFor="let line of obsCategoryItemsByLines.changes$ | async; index as lineIndex;">
		<ng-container *ngFor="let column of line.items; index as columnIndex">
			<!-- On veut 3 colonnes max de même taille. -->
			<ion-col *ngIf="columnIndex < 3" [size]="4">
				<!-- On génère la tuile uniquement si elle existe (pas de valeur == espace vide). -->
				<ng-container *ngIf="!!column">
					<calao-category-tile [title]="column.title"
						[titleColor]="column.isLastSelected ? column.focusedTitleColor : column.titleColor"
						[titleBackgroundColor]="column.isLastSelected ? column.focusedTitleBackgroundColor : column.titleBackgroundColor"
						[value]="column.quantity.toString()"
						[valueColor]="column.isLastSelected ? column.focusedQtyColor : column.qtyColor"
						[valueBackgroundColor]="column.isLastSelected ? column.focusedQtyBackgroundColor : column.qtyBackgroundColor"
						[icon]="column.icon" [hasBorder]="column.isLastSelected" [borderColor]="column.borderColor"
						(click)="raiseCategoryItemClicked(column)">
					</calao-category-tile>
				</ng-container>
			</ion-col>
		</ng-container>
	</ion-row>
</ng-template>

<ng-template #oldContent>
	<ng-container *ngFor="let category of obsCategories.changes$ | async; index as i;">
		<!-- Tableau de 3 par 3. -->
		<ion-row *ngIf="i % 3 === 0">
			<ion-col size="4">
				<ng-container *ngTemplateOutlet="oldColumn; context: { category: obsCategories[i], index: i}"></ng-container>
			</ion-col>
			<ion-col *ngIf="obsCategories.length > i+1" size="4">
				<ng-container
					*ngTemplateOutlet="oldColumn; context: { category: obsCategories[i+1], index: i+1}"></ng-container>
			</ion-col>
			<ion-col *ngIf="obsCategories.length > i+2" size="4">
				<ng-container
					*ngTemplateOutlet="oldColumn; context: { category: obsCategories[i+2], index: i+2}"></ng-container>
			</ion-col>
		</ion-row>
	</ng-container>
</ng-template>

<!-- todo : supprimer ce template une fois la migration des merchs effectuée. -->
<ng-template #oldColumn let-category="category" let-index="index">
	<calao-category-tile [title]="category.title" [value]="category.quantity" [titleColor]="category.color"
		[icon]="category.icon" [isOldDisplaying]="true" [subtitle]="category.subtitle"
		(click)="onCategoryClick({category: $any(category), index: index})">
	</calao-category-tile>
</ng-template>